import script from "./PopupContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupContainer.vue?vue&type=script&setup=true&lang=js"

import "./PopupContainer.vue?vue&type=style&index=0&id=6ef4a7e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\ASIC\\MulticaseVue\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ef4a7e0"]])

export default __exports__